module.exports = __webpack_public_path__ + "static/media/right_illustration.029b33f4.svg";